module.exports = __webpack_public_path__ + "img/logoSmg.610fb252.png";